module.exports = new __parcel__URL__("BYO.cb08927a.svg").toString();